import React, {useContext} from "react";
import { AuthContext, IntlContext } from "context";
import { TextView } from "ui/View";
import { Role } from "types/user";
import ImageUpload from "components/File/ImageUpload";
import moment from "moment";
import { useReferences } from "hooks/reference";
import { COUNTRY_CODE_FRA } from "types/reference";

const ProfileCommonView: React.FC<{}> = () => {
    const intl = useContext(IntlContext);
    const { account, currentRole } = useContext(AuthContext);
    const reference = useReferences();
    const countries = reference.all('countries');
    const accountCountry = countries.filter((c) => c.code_iso === account?.user.country_birth_code).shift();
    const franceCountry = countries.filter((c) => c.code === COUNTRY_CODE_FRA).shift();
    /*const { isLoading, data } = useQuery({ queryKey: ["company-limit"], queryFn: dataFetcher.companyLimit });

    if (isLoading || !data) {
        return <Loader />;
    }*/

    return (
        <React.Fragment>
            {currentRole === Role.CLIENT && (
                <div className="register__group-fields">
                    <div className="register__grid profile_header">
                            <div className="profile_image">
                                <div className="flex flex--justify-content-center">
                                    <ImageUpload id={account?.user.picture_id} />
                                </div>
                            </div>
                    </div>
                </div>
            )}

            <div className="register__group-fields">
                <div className="register__grid">
                    <div className="grid--2 grid--small-1 grid--has-gutter-3x register__grid">
                        <TextView
                            label={intl.formatMessage("profile.label.gender")}
                            value={intl.formatMessage(`generic.label.gender.${account?.user.gender}`)}
                        />
                        <TextView
                            label={intl.formatMessage("profile.label.birth_name")}
                            value={account?.user?.birth_name}
                        />
                        <TextView
                            label={intl.formatMessage("profile.label.last_name")}
                            value={account?.user?.last_name}
                        />
                        <TextView
                            label={intl.formatMessage("profile.label.first_name")}
                            value={account?.user?.first_name}
                        />
                        <TextView
                            label={intl.formatMessage("profile.label.email")}
                            value={account?.user.email}
                        />
                        <TextView
                            label={intl.formatMessage("profile.label.phone")}
                            value={account?.user?.phone ?? ""}
                        />

                        {currentRole === Role.CLIENT && (
                            <>
                                <TextView
                                    label={intl.formatMessage("profile.label.birthday")}
                                    value={account?.resources?.client[0].birthday ? moment(account?.resources?.client[0].birthday).format("DD/MM/YYYY") : ""}
                                />
                                {account?.user.country_birth_code === franceCountry?.code_iso ? (
                                    <TextView
                                        label={intl.formatMessage("register.label.city.birth")}
                                        value={account?.user.city_birth ?? ""}
                                    />
                                ) : (
                                    <TextView
                                        label={intl.formatMessage("register.label.country.birth")}
                                        value={accountCountry?.value}
                                    />
                                )}
                            </>
                        )}

                        {currentRole === Role.PROVIDER && (
                            <>
                                <TextView
                                    label={intl.formatMessage("profile.label.birthday")}
                                    labelClassname="field__label profile--provider_mandatory_field"
                                    value={account?.resources?.provider[0].birthday ? moment(account?.resources?.provider[0].birthday).format("DD/MM/YYYY") : ""}
                                />
                                {account?.user.country_birth_code === franceCountry?.code_iso ? (
                                    <TextView
                                        label={intl.formatMessage("register.label.city.birth")}
                                        labelClassname="field__label profile--provider_mandatory_field"
                                        value={account?.user.city_birth ?? ""}
                                    />
                                ) : (
                                    <TextView
                                        label={intl.formatMessage("register.label.country.birth")}
                                        labelClassname="field__label profile--provider_mandatory_field"
                                        value={accountCountry?.value}
                                    />
                                )}
                                <TextView
                                    label={intl.formatMessage("profile.label.nir")}
                                    labelClassname="field__label profile--provider_mandatory_field"
                                    value={account?.resources?.provider[0].nir ?? ""}
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div className="register__group-fields">
                <div className="grid--1 grid--small-1 grid--has-gutter-3x register__grid">
                    <TextView label={intl.formatMessage("profile.label.address")} value={account?.user.address} />
                </div>
            </div>
            {currentRole === Role.CLIENT && (
                <div className="register__group-fields">
                    <div className="grid--2 grid--small-1 grid--has-gutter-3x register__grid">
                        <TextView
                            label={intl.formatMessage("profile.label.has_pet")}
                            value={
                                account?.resources?.client[0].has_pet
                                    ? intl.formatMessage("generic.label.yes")
                                    : intl.formatMessage("generic.label.no")
                            }
                        />
                        {account?.resources?.client[0].has_pet && (
                            <TextView
                                label={intl.formatMessage("profile.label.pet_type")}
                                value={account?.resources?.client[0].pet_type?.map((pet_type, key) => {
                                    let petsTypeLength = account?.resources?.client[0].pet_type?.length ?? 0;
                                    let translatedPetType = reference.get("pet_type", pet_type)?.value_normalized;

                                    if (key + 1 < petsTypeLength) {
                                        return `${translatedPetType}`;
                                    }

                                    return `${translatedPetType}`;
                                })}
                            />
                        )}
                    </div>
                    <div className="grid--1 grid--small-1 grid--has-gutter-3x register__grid">
                        {account?.resources?.client[0].services && (
                            <TextView
                                label={intl.formatMessage("profile.label.services")}
                                value={
                                    Array.isArray(account?.resources?.client[0].services)
                                        ? account?.resources?.client[0].services.map((service) => {
                                              return intl.formatMessage("category." + String(service).toLowerCase());
                                          })
                                        : []
                                }
                            />
                        )}
                        {/*<TextView
                            label={intl.formatMessage("profile.label.is_attach_company")}
                            value={
                                account?.resources?.client[0].company_id
                                    ? intl.formatMessage("generic.label.yes")
                                    : intl.formatMessage("generic.label.no")
                            }
                        />*/}
                    </div>
                    {/*account?.resources?.client[0].company_id ? (
                        <React.Fragment>
                            <div className="grid--2 grid--small-1 grid--has-gutter-3x register__grid">
                                <TextView
                                    label={intl.formatMessage("profile.label.name_company")}
                                    value={account?.resources?.client[0].company_name}
                                />
                                <TextView
                                    label={intl.formatMessage("profile.label.code_company")}
                                    value={account?.resources?.client[0].company_code}
                                />
                            </div>
                            <div className="grid--2 grid--small-1 grid--has-gutter-3x register__grid">
                                <Slider
                                    name="ceiling_company"
                                    min={0}
                                    max={Number(data.companyLimit)}
                                    value={Number(data.companyLimitUse)}
                                    unit={"€"}
                                    label={{
                                        name: "profile.label.money_left",
                                        props: {
                                            money: Number(data.companyLimit) - Number(data.companyLimitUse),
                                        },
                                    }}
                                />
                            </div>
                        </React.Fragment>
                    ) : null*/}
                    <div className="grid--1 grid--small-1 grid--has-gutter-3x register__grid">
                        <TextView
                            label={intl.formatMessage("profile.label.other_informations")}
                            value={account?.resources?.client[0].comment || ""}
                        />
                    </div>
                </div>
            )}

            {currentRole === Role.PROVIDER && (
                <React.Fragment>
                    <div className="register__group-fields">
                        <div className="grid--2 grid--small-1 grid--has-gutter-3x register__grid">
                            <TextView
                                label={intl.formatMessage("profile.label.csp")}
                                value={intl.formatMessage(`profile.label.csp.${account?.resources?.provider[0].csp}`)}
                            />
                        </div>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default ProfileCommonView;
